import { getSubscriptionApiClient } from "../../shared/apis/sidekick/api-factories";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { toast } from "@shared/services/toast";
import { appLogger } from "@shared/services/app-logger";
import { buildAdminGetUserSubscriptionStatusQueryKey } from "./useAdminGetUserSubscription";

type Props = {
  onSuccess?: () => void;
};

export const useAdminCancelUserSubscriptionAtPeriodEnd = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ["admin-subscription", "cancel-at-period-end"],
    mutationFn: async ({ userId }: { userId: string }) => {
      const response =
        await api.subscriptionControllerAdminCancelSubscriptionAtPeriodEnd({
          userId,
        });
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: buildAdminGetUserSubscriptionStatusQueryKey({ userId }),
        });
      }, 1000);
      onSuccess?.();
      return response;
    },
    onError: async (error, { userId }) => {
      const apiError = await apiResponseErrorHandler(error);
      if (apiError.status >= 400 && apiError.status < 500) {
        toast.error(apiError.errors[0]);
        return;
      }
      toast.error(
        `Failed to cancel user subscription with user ID ${userId}. If the issue persists, please contact support.`,
      );
      appLogger.error(`Failed to cancel subscription`, { error });
    },
  });

  return mutation;
};
